import React, {Component} from "react";
import './../../../node_modules/izitoast/dist/css/iziToast.min.css';
import {withTranslate} from "react-redux-multilingual"
import {connect} from "react-redux"
import globalMiddleware from "../../hocs/globalMiddleware"
import {
    clearDoctorList,
    clearSearchData,
    getAuthFollowedDoctors,
    getCitiesList,
    getSearchData,
    requestDoctorsPage,
    searchFromFooter,
    setSearchData,
} from "../../store/actions/doctorActions";
import {getSpecialtiesList} from "./../../store/actions/specialtyActions"
import {withRouter} from "react-router-dom";
import Select from 'react-select';
import {withLastLocation} from 'react-router-last-location';

class Search extends Component {

    state = {
        keyword: "",
        city: null,
        province: null,
        specialty: null,
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.currentSearchData) {
            this.setState({
                specialty: nextProps.currentSearchData.specialty,
                keyword: nextProps.currentSearchData.keyword,
                city: nextProps.currentSearchData.city,
                province: nextProps.currentSearchData.province,

            }, () => {
                console.log(this.state.specialty);
            });
        }
    }

    componentDidMount() {
        /* if ((this.props.lastLocation && this.props.lastLocation.pathname.includes("RK_ACC")) === false && document.referrer.includes("RK_ACC") === false) {
             this.props.clearSearchData();
         }*/
        this.props.getCitiesList();
        this.props.getSpecialtiesList();
    }

    hideIcon = () => {
        let icon = document.getElementById("city_icon");
        console.log("ppp", icon)
        if (icon) {
            icon.style.display = "none";
        }
    }
    handleCityOnChange = (selectedOption) => {
        this.setState({city: selectedOption.value});
    };
    handleProvinceOnChange = (selectedOption) => {
        this.setState({province: selectedOption.value});
    };
    handleSpecialtyOnChange = (selectedOption) => {
        this.setState({specialty: selectedOption.value});
    };
    handleCityOnChangeMobile = (e) => {
        document.getElementById("province").selectedIndex = "0";
        this.setState({city: JSON.parse(e.target.value)});
    };
    handleProvinceOnChangeMobile = (e) => {
        this.setState({province: JSON.parse(e.target.value)});
    };
    handleSpecialtyOnChangeMobile = (e) => {
        this.setState({specialty: JSON.parse(e.target.value)});
    };
    handleKeywordChange = (e) => {
        this.setState({
            keyword: e.target.value
        })
    };


    handleSetCurrentSearchData = (data = this.state) => {
        this.props.searchFromFooter(false);
        this.props.setSearchData(data);
        localStorage.setItem("searchData", JSON.stringify(data));

        if (this.props.match.path === "/doctors") {
            this.props.clearDoctorList();
            const keyword = this.state.keyword;
            const city = this.state.city && this.state.city !== {} ? this.state.city.id : null;
            const province = this.state.province && this.state.province !== {} ? this.state.province.id : null;
            const specialty = this.state.specialty && this.state.specialty !== {} ? this.state.specialty.slug : "";
            this.props.requestDoctorsPage(1, specialty, keyword, specialty, null, city, province);
        } else {
            this.props.history.push("/doctors");
            // call get search data to update doc
        }
    };


    clearSearchKey = async (key) => {
        let state = {
            ...this.state
        };
        switch (key) {
            case "keyword":
                state = {...state, keyword: null};
                break;
            case "city":

                state = {...state, city: null};
                break;

            case "province":
                state = {...state, province: null};
                break;

            case "specialty":
                state = {...state, specialty: null};
                break;
            default:
            //
        }

        await this.setState({
            ...state
        }, () => {
            this.props.clearSearchData();
            // this.handleSetCurrentSearchData(this.state);
        });
    };

    render() {
        let cities = [];
        let citiesMobile = [];
        if (this.props.cities && this.props.cities.length) {
            this.props.cities.forEach((city) => {
                if (!this.props.mobileMenuIsShown) {
                    cities = [...cities, {
                        value: city,
                        label: city.name
                    }]
                } else {
                    citiesMobile = [...citiesMobile,
                        <option value={JSON.stringify(city)}>{city.name}</option>
                    ]
                }
            });
        }

        let provinces = [];
        let provincesMobile = [];
        if (this.state.city && this.state.city.provinces) {
            this.state.city.provinces.forEach((province) => {
                if (!this.props.mobileMenuIsShown) {
                    provinces = [...provinces, {
                        value: province,
                        label: province.name
                    }]
                } else {
                    provincesMobile = [...provincesMobile,
                        <option value={JSON.stringify(province)}>{province.name}</option>
                    ]
                }
            });
        }


        let specialties = [];
        let specialtiesMobile = [];
        if (this.props.specialties && this.props.specialties.length) {
            this.props.specialties.forEach((specialty) => {
                if (!this.props.mobileMenuIsShown) {
                    specialties = [...specialties, {
                        value: specialty,
                        label: specialty.speciality
                    }]
                } else {
                    specialtiesMobile = [...specialtiesMobile,
                        <option value={JSON.stringify(specialty)}>{specialty.speciality}</option>
                    ]
                }
            });
        }


        // let provinceLabel = this.props.currentSearchData && this.props.currentSearchData.province ? this.props.currentSearchData.province.name : "Province ...";

        return (
            <section className="main-search ">

                <div className="container">
                    <div className="row shadow-4d search-box-with-shadow">
                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-3 full-height no-padding border-bottom" : "col-md-3 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height border-right" style={{cursor: "inherit"}}>
                                    {/*<div className="form-label capitalized">
                                        <label>{this.props.translate("doctor_name")}</label>
                                    </div>*/}

                                    <div className="full-height">
                                        <i className="fa fa-user-md profile-icon"></i>
                                        <input onChange={(e) => this.handleKeywordChange(e)}
                                               value={this.state.keyword}
                                               type="text"
                                               onFocus={(e) => e.target.placeholder = ""}
                                               onBlur={(e) => e.target.placeholder = this.props.translate("keywordPlaceHolder")}
                                               className="form-control full-height  doctor-name-search"
                                               placeholder={this.props.currentSearchData && this.props.currentSearchData.keyword && this.props.currentSearchData.keyword !== "" ? this.props.currentSearchData.keyword : this.props.translate("keywordPlaceHolder")}/>
                                    </div>
                                </div> :
                                <input onChange={(e) => this.handleKeywordChange(e)}
                                       value={this.state.keyword}
                                       type="text"
                                       onFocus={(e) => e.target.placeholder = ""}
                                       onBlur={(e) => e.target.placeholder = this.props.translate("keywordPlaceHolder")}
                                       className="select-option p-l-8 doctor-name-search"
                                       placeholder={this.props.currentSearchData && this.props.currentSearchData.keyword && this.props.currentSearchData.keyword !== "" ? this.props.currentSearchData.keyword : this.props.translate("keywordPlaceHolder")}/>
                            }
                        </div>
                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-2 full-height no-padding border-bottom" : "col-md-2 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height border-right">
                                    {/*<div className="form-label capitalized">
                                        <label>{this.props.translate("city")}</label>
                                    </div>*/}
                                    <div className="full-height">
                                        <i className="fas fa-city search-icon"></i>
                                        <Select
                                            className={this.state.city ? "currentSearchData full-height select-custom-styles capitalized" : "select-custom-styles full-height capitalized"}
                                            placeholder={this.state.city ? this.state.city.name : this.props.translate("city") + "..."}
                                            onChange={this.handleCityOnChange}
                                            options={cities}
                                            value={this.state.city ? this.state.city.name : null}
                                        />

                                    </div>
                                </div>
                                :
                                <select
                                    className="mobile-select custom-select capitalized"
                                    onChange={this.handleCityOnChangeMobile}
                                >
                                    <option value="" disabled
                                            selected>{this.props.translate("city") + "..."}</option>
                                    {citiesMobile}
                                </select>}

                        </div>
                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-2 full-height no-padding border-bottom" : "col-md-2 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height border-right">
                                    {/* <div className="form-label capitalized">
                                        <label>{this.props.translate("province")}</label>
                                    </div>*/}
                                    <div className="full-height">
                                        <i className="fas fa-building search-icon"></i>
                                        <Select
                                            className={this.state.province ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                            placeholder={this.state.province ? this.state.province.name : this.props.translate("province") + "..."}
                                            onChange={this.handleProvinceOnChange}
                                            options={provinces}
                                            value={this.state.province ? this.state.province.name : null}
                                        />
                                    </div>
                                </div> :
                                <select id="province"
                                        className="mobile-select custom-select capitalized"
                                        onChange={this.handleProvinceOnChangeMobile}
                                >
                                    <option value="" disabled
                                            selected>{this.props.translate("province") + "..."}</option>
                                    {provincesMobile}
                                </select>
                            }

                        </div>
                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-3 full-height no-padding border-bottom" : "col-md-3 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height border-right">
                                    {/*  <div className="form-label capitalized">
                                        <label>{this.props.translate("specialty")}</label>
                                    </div>*/}

                                    <div className="full-height">
                                        <i className="fa fa-stethoscope search-icon"></i>
                                        <Select
                                            className={this.state.specialty ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                            placeholder={this.state.specialty ? this.state.specialty.speciality : this.props.translate("specialty") + "..."}
                                            onChange={this.handleSpecialtyOnChange}
                                            options={specialties}
                                            value={this.state.specialty ? this.state.specialty.speciality : null}
                                        />
                                    </div>

                                </div>
                                : <select
                                    className="mobile-select custom-select capitalized"
                                    onChange={this.handleSpecialtyOnChangeMobile}
                                >
                                    <option value="" disabled
                                            selected>{this.props.translate("specialty") + "..."}</option>
                                    {specialtiesMobile}
                                </select>}
                        </div>
                        <div className="col-md-2 full-height no-padding">
                            <button onClick={() => this.handleSetCurrentSearchData()}
                                    className="btn btn-block full-height">
                                <span className="font-20  m-r-5">{this.props.translate('search')}</span>
                                {/*<i className="fa fa-search font-20"></i>*/}
                            </button>
                        </div>
                    </div>

                    <div className="row mt-20">
                        <div className="col-md-12">
                            <div className="search-key">
                                 <span className="block shadow-4d search-key-span"
                                       hidden={!this.state.keyword}>
                                {this.state.keyword !== "" ? this.state.keyword : ""}
                                     <i className="fas fa-times pull-right"
                                        onClick={() => this.clearSearchKey("keyword")}></i></span>


                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.city}>
                                {this.state.city ? this.state.city.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("city")}></i>
                                </span>

                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.province}>
                                {this.state.province ? this.state.province.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("province")}></i>
                                </span>


                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.specialty}>
                                {this.state.specialty ? this.state.specialty.speciality : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("specialty")}></i>
                                </span>

                                {/* <span className="block shadow-4d search-key-span"
                                      hidden={this.state.province === null || this.state.province === "" || (Object.keys(this.state.province).length === 0 && this.state.province.constructor === Object)}>
                                {this.state.province.name}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("province")}></i>
                                </span>

                                <span className="block shadow-4d search-key-span"
                                      hidden={this.state.specialty === null || this.state.specialty === "" || (Object.keys(this.state.specialty).length === 0 && this.state.specialty.constructor === Object)}>
                                {this.state.specialty.speciality}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("specialty")}></i>
                                </span>*/}
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        cities: state.doctor.cities,
        citiesIsLoading: state.doctor.citiesIsLoading,
        currentSearchData: state.doctor.currentSearchData,
        specialties: state.specialty.specialties,
        specialtyListIsLoading: state.specialty.specialtyListIsLoading,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCitiesList: () => dispatch(getCitiesList()),
        getSpecialtiesList: () => dispatch(getSpecialtiesList()),
        setSearchData: (data) => dispatch(setSearchData(data)),
        getSearchData: () => dispatch(getSearchData()),
        requestDoctorsPage: (page, specialtyString, keyword, slug, sort, city_id, province_id) => dispatch(requestDoctorsPage(page, specialtyString, keyword, slug, sort, city_id, province_id)),
        clearDoctorList: () => dispatch(clearDoctorList()),
        clearSearchData: () => dispatch(clearSearchData()),
        searchFromFooter: (data) => dispatch(searchFromFooter(data)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(withRouter(withLastLocation(Search)))))


/// References ////////
//// https://www.npmjs.com/package/izitoast/v/1.0.2




